<ng-container>
  <div class="ppt-body-content">
    <div class="record-address-section">
      <ppt-record-header
        [reportData]="reportData"
        [reportRecordData]="reportRecordData"
        [currentView]="currentView"
        [headerFields]="headerFields"
        [templateProjectionMap]="templateProjectionMap"
      ></ppt-record-header>
    </div>
    <div class="record-img-attribute-section">
      <div class="record-img-content">
        <ppt-record-image
          *ngIf="!isSecondaryImageRequired"
          [reportId]="reportData?.reportId"
          [reportRecordData]="reportRecordData"
          [allFields]="allFields"
          [currentView]="currentView"
        ></ppt-record-image>
        <rep-presentation-dynamic-view-image
          *ngIf="isSecondaryImageRequired"
          [reportId]="reportData?.reportId"
          [reportRecordData]="reportRecordData"
          [imageGroups]="imageGroups"
          [currentView]="currentView"
        ></rep-presentation-dynamic-view-image>
      </div>
      <div class="body-content">
        <ng-container *ngIf="currentView?.templateId != null; else noValidData">
          <div class="record-attribute-content">
            <ul class="record-list">
              <li *ngIf="confidentialityTmpl && !isSecondaryImageRequired">
                <ng-container
                  *ngTemplateOutlet="confidentialityTmpl; context: { reportItem: reportRecordData, displayLabel: true }"
                ></ng-container>
              </li>
              <li *ngFor="let field of allDataFields" (click)="emitEditableFields($event, field.id)">
                <label
                  class="record-attribute-key"
                  [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
                  >{{ reportRecordData | reportLabelFormatter: { templateId: currentView.templateId, field: field } }}
                </label>
                <span
                  class="record-attribute-value"
                  [ngClass]="{ clickable: editableFieldsService.editableTemplateAttributes[field.id] }"
                  >{{
                    reportRecordData
                      | reportFieldFormatter
                        : {
                            templateId: currentView.templateId,
                            field: field,
                            joinString: true,
                            onlyUrl: false,
                            symbols: customConfigs?.symbols,
                          }
                      | async
                  }}</span
                >
              </li>
            </ul>
          </div>
        </ng-container>
        <ng-template #noValidData>
          <!-- TODO: add localization-->
          <div>No data available</div>
        </ng-template>
        <ng-container>
          <div
            class="bottom-section"
            [ngClass]="tableFields?.fields?.length ? 'inline-bottom-section' : ''"
            *ngIf="isSecondaryImageRequired"
          >
            <div class="table-section" *ngIf="tableFields">
              <h3 class="table-title" *ngIf="tableFields.tableConfigs?.tableTitle">
                {{ reportRecordData?.data.length }}
                {{
                  (reportRecordData?.data.length > 0 ? 'template.availabilities' : 'template.availability') | xTranslate
                }}
              </h3>
              <table aria-hidden="true" class="template-table">
                <thead>
                  <tr>
                    <th scope="col" *ngIf="tableFields.tableConfigs?.actionCol"></th>
                    <ng-container *ngFor="let col of tableFields.fields">
                      <th
                        scope="col"
                        *ngIf="reportRecordData | isFieldVisible: { templateId: currentView.templateId, field: col }"
                        [ngClass]="col.class"
                      >
                        <span>{{ col.label }}</span>
                      </th>
                    </ng-container>
                    <th scope="col" *ngIf="confidentialityTmpl">
                      {{ 'template.reportConfidentiality' | xTranslate }}
                    </th>
                  </tr>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="onReorder($event, reportRecordData)">
                  <tr *ngFor="let data of tableData; let i = index" cdkDrag cdkDragLockAxis="y">
                    <td *ngIf="tableFields.tableConfigs?.actionCol" class="actions">
                      <a class="action-element"
                        ><mat-icon
                          class="handle print-hidden"
                          svgIcon="alt-handle-icon"
                          color="y-icon"
                          cdkDragHandle
                        ></mat-icon
                      ></a>
                      <a class="action-element" (click)="removeRecord.emit(data)"
                        ><mat-icon class="green-close" color="y-icon" svgIcon="close-icon-grey"></mat-icon
                      ></a>
                      <!-- TODO: instead of goToRecordDetails() method need to use miq-goes-to-record once feild from BE is available -->
                      <a (click)="goToRecordDetails(data)" class="action-element">
                        <mat-icon class="print-hidden" color="y-icon" svgIcon="open_in_browser"> </mat-icon>
                      </a>
                      <strong>{{ i + 1 }}.</strong>
                    </td>
                    <ng-container *ngFor="let col of tableFields.fields; let i = index">
                      <td *ngIf="reportRecordData | isFieldVisible: { templateId: currentView.templateId, field: col }">
                        <span>{{
                          { recordId: null, position: null, edpRecordId: null, confidentiality: null, data: [data] }
                            | reportFieldFormatter
                              : {
                                  templateId: currentView.templateId,
                                  field: col,
                                  joinString: true,
                                  onlyUrl: false,
                                }
                            | async
                        }}</span>
                      </td>
                    </ng-container>
                    <td *ngIf="confidentialityTmpl">
                      <div class="confidentialityInTable">
                        <ng-container
                          style="position: absolute"
                          *ngTemplateOutlet="
                            confidentialityTmpl;
                            context: {
                              record: data,
                              reportItem: reportRecordData,
                              displayLabel: true,
                              isDataOnly: true,
                            }
                          "
                        ></ng-container>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="tableData?.length === 0">
                    <td [attr.colspan]="tableFields.tableConfigs.colspan" l10nTranslate>template.noData</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="floorPlanTemplateIds">
          <floor-plan [reportId]="reportData?.reportId" [reportRecordData]="reportRecordData"></floor-plan>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
